export const any = xs => xs && xs.length > 0;

export const filterBy = by => array => array.filter(by);

export const removeItem = (arr, value) => {
  const index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
};

export const allElementsEqual = arr => {
  return new Set(arr).size === 1;
};
